/**
 * Generate a random number between a min and max value
 */
export default (min, max) => Math.floor(Math.random() * ((max - min) + 1)) + min;
